import React from 'react';
import { isNil } from 'lodash';
import WidgetPreviewTitle from '../../WidgetPreviewTitle';
import WidgetPreviewEventSwipeLayout from '../WidgetPreviewEventSwipeLayout';
import './WidgetPreviewEventWrap.scss';

const WidgetPreviewEventWrap = (props) => {
  const { no, widgetInfo, exposureWidgetItemList } = props;
  const { mainTitle, isUsedSubTitle, subTitle } = widgetInfo;

  return (
    <div className="widget-preview-event-wrap">
      {
        /**
         *  위젯 타이틀, 위젯 서브 타이틀
         */
        isNil(no) || no !== 0 ? (
          <WidgetPreviewTitle mainTitle={mainTitle} isUsedSubTitle={isUsedSubTitle} subTitle={subTitle} />
        ) : null
      }

      <div className="widget-event-item-list">
        <div className="widget-event-section">
          <WidgetPreviewEventSwipeLayout list={exposureWidgetItemList} />
        </div>
      </div>
    </div>
  );
};

export default WidgetPreviewEventWrap;
